<div class="custom-box" *ngIf="isDataAvailable()">
  <section class="blue-theme">
    <div class=" row grid">
      <div class="col-lg-11  taxpayer-section mb3  ">
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
          <div class=" ">
            <span *ngFor="let tradwData of tradwDataList;let i = index">
              <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="tradwData.contentType?.titleEn"
                [textHi]="tradwData.contentType?.titleHi"></cbic-static-text>
            </span>
            <span>
              <div class="content-list">
                <ul class="custom-scroll-bar">
                  <li *ngFor="let tradwData of tradwDataList">
                    <a href="{{tradwData.path}}" target="_blank"></a>
                    <cbic-link [linkTextEn]="tradwData.titleEn" [linkTextHi]="tradwData.titleHi"
                      [linkEn]="tradwData.path" [linkHi]="tradwData.path"></cbic-link>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
          <div class="">
            <span *ngFor="let reportData of reportDataList;let i = index">
              <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="reportData.contentType?.titleEn"
                [textHi]="reportData.contentType?.titleHi"></cbic-static-text>
            </span>

            <span>
              <div class="content-list">
                <ul class="custom-scroll-bar">
                  <li *ngFor="let reportData of reportDataList">
                    <a href="{{reportData.path}}" target="_blank"></a>
                    <cbic-link [linkTextEn]="reportData.titleEn" [linkTextHi]="reportData.titleHi"
                      [linkEn]="reportData.path" [linkHi]="reportData.path"></cbic-link>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>

        <div class="col-xs-12 col-md-6 col-lg-4 card solution_card EoDB">
          <div class="">
            <span *ngFor="let citizenData of citizenDataList;let i = index">
              <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="citizenData.contentType?.titleEn"
                [textHi]="citizenData.contentType?.titleHi"></cbic-static-text>
            </span>

            <span>
              <div class="content-list">
                <ul class="custom-scroll-bar">
                  
                  <li *ngFor="let citizenData of citizenDataList">
                    <a href="{{citizenData.path}}" target="_blank"></a>
                    <cbic-link [linkTextEn]="citizenData.titleEn" [linkTextHi]="citizenData.titleHi"
                      [linkEn]="citizenData.path" [linkHi]="citizenData.path"></cbic-link>
                  </li>
				  
                  
        
                </ul>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-11 taxpayer-section">
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
          <div class="">
            <!-- <span class="float-start Header">Stakeholder Consultation Public Information</span> -->
            <span *ngFor="let stackeholderyData of stackeholderyDataList;let i = index">
              <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="stackeholderyData.contentType?.titleEn"
                [textHi]="stackeholderyData.contentType?.titleHi"></cbic-static-text>
            </span>

            <span>
              <div class="content-list">
                <ul class="custom-scroll-bar" style="height: 15vh;">
                  <li *ngFor="let stackeholderyData of stackeholderyDataList">
                    <a href="{{stackeholderyData.path}}" target="_blank"></a>
                    <cbic-link [linkTextEn]="stackeholderyData.titleEn" [linkTextHi]="stackeholderyData.titleHi"
                      [linkEn]="stackeholderyData.path" [linkHi]="stackeholderyData.path"></cbic-link>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
          <div class="">
            <span *ngFor="let contactData of contactDataList;let i = index">
              <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="contactData.contentType?.titleEn"
                [textHi]="contactData.contentType?.titleHi"></cbic-static-text>
            </span>

            <span>
              <div class="content-list">
                <ul class="custom-scroll-bar">
                  <li *ngFor="let contactData of contactDataList">
                    <a href="{{contactData.path}}" target="_blank"></a>
                    <cbic-link [linkTextEn]="contactData.titleEn" [linkTextHi]="contactData.titleHi"
                      [linkEn]="contactData.path" [linkHi]="contactData.path"></cbic-link>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
          <div class="">
            <span *ngFor="let otherData of otherDataList;let i = index">
              <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="otherData.contentType?.titleEn"
                [textHi]="otherData.contentType?.titleHi"></cbic-static-text>
            </span>
            <span>
              <div class="content-list">
                <ul class="custom-scroll-bar">
                  <li *ngFor="let otherData of otherDataList">
                    <a href="{{otherData.path}}" target="_blank"></a>
                    <cbic-link [linkTextEn]="otherData.titleEn" [linkTextHi]="otherData.titleHi"
                      [linkEn]="otherData.path" [linkHi]="otherData.path"></cbic-link>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
